/**
 * @generated SignedSource<<cc17e71b9350556f4415d0b083862cae>>
 * @relayHash 4257b78a458e32e70bf16869db78cf05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceInlineTaskStatus = "COMPLETE" | "INCOMPLETE" | "%future added value";
export type InlineTasksQuerySortColumn = "ASSIGNEE" | "DUE_DATE" | "PAGE_TITLE" | "%future added value";
export type InlineTasksQuerySortOrder = "ASCENDING" | "DESCENDING" | "%future added value";
export type TaskStatus = "CHECKED" | "UNCHECKED" | "%future added value";
export type InlineTasksByMetadata = {
  accountIds?: InlineTasksQueryAccountIds | null;
  after?: string | null;
  completedDateRange?: InlineTasksQueryDateRange | null;
  createdDateRange?: InlineTasksQueryDateRange | null;
  dueDate?: InlineTasksQueryDateRange | null;
  first: number;
  forCurrentPageOnly?: boolean | null;
  isNoDueDate?: boolean | null;
  labels?: ReadonlyArray<string | null> | null;
  pageIds?: ReadonlyArray<AGG$Long | null> | null;
  sortParameters?: InlineTasksQuerySortParameters | null;
  spaceIds?: ReadonlyArray<AGG$Long | null> | null;
  spaceKeys?: ReadonlyArray<string | null> | null;
  status?: TaskStatus | null;
};
export type InlineTasksQueryAccountIds = {
  assigneeAccountIds?: ReadonlyArray<string | null> | null;
  completedByAccountIds?: ReadonlyArray<string | null> | null;
  creatorAccountIds?: ReadonlyArray<string | null> | null;
};
export type InlineTasksQueryDateRange = {
  endDate?: AGG$Long | null;
  startDate?: AGG$Long | null;
};
export type InlineTasksQuerySortParameters = {
  sortColumn: InlineTasksQuerySortColumn;
  sortOrder: InlineTasksQuerySortOrder;
};
export type GetTasksReportQuery$variables = {
  cloudId?: string | null;
  taskQuery: InlineTasksByMetadata;
};
export type GetTasksReportQuery$data = {
  readonly inlineTasks: {
    readonly endCursor: string | null;
    readonly inlineTasks: ReadonlyArray<{
      readonly assignedTo: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly body: {
        readonly adf: string | null;
      } | null;
      readonly completedAt: string | null;
      readonly container: {
        readonly __typename: "ConfluenceBlogPost";
        readonly blogPostId: string;
        readonly id: string;
        readonly labels: ReadonlyArray<{
          readonly label: string | null;
          readonly prefix: string | null;
        } | null> | null;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly name: string | null;
          readonly spaceId: string;
        } | null;
        readonly title: string | null;
      } | {
        readonly __typename: "ConfluencePage";
        readonly id: string;
        readonly labels: ReadonlyArray<{
          readonly label: string | null;
          readonly prefix: string | null;
        } | null> | null;
        readonly links: {
          readonly base: string | null;
          readonly webUi: string | null;
        } | null;
        readonly pageId: string;
        readonly space: {
          readonly id: string;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
          readonly name: string | null;
          readonly spaceId: string;
        } | null;
        readonly title: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
      readonly createdAt: string | null;
      readonly createdBy: {
        readonly accountId: string;
        readonly displayName: string | null;
      } | null;
      readonly dueAt: string | null;
      readonly id: string;
      readonly status: ConfluenceInlineTaskStatus | null;
      readonly taskId: string | null;
    } | null> | null;
  } | null;
};
export type GetTasksReportQuery = {
  response: GetTasksReportQuery$data;
  variables: GetTasksReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskQuery"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "tasksQuery",
    "variableName": "taskQuery"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "taskId"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = {
  "kind": "ScalarField",
  "name": "dueAt"
},
v7 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v8 = {
  "kind": "ScalarField",
  "name": "completedAt"
},
v9 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v10 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v11 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "profilePicture",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    }
  ]
},
v12 = {
  "concreteType": "GraphQLUserInfo",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ]
},
v13 = {
  "concreteType": "ConfluenceContentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "adf"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "pageId"
},
v16 = {
  "kind": "ScalarField",
  "name": "title"
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v18 = {
  "concreteType": "ConfluencePageLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v17/*: any*/)
},
v19 = {
  "kind": "ScalarField",
  "name": "label"
},
v20 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v21 = {
  "concreteType": "ConfluenceLabel",
  "kind": "LinkedField",
  "name": "labels",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/)
  ]
},
v22 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "spaceId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v17/*: any*/)
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "blogPostId"
},
v24 = {
  "concreteType": "ConfluenceBlogPostLinks",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v17/*: any*/)
},
v25 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v26 = {
  "concreteType": "ConfluenceLabel",
  "kind": "LinkedField",
  "name": "labels",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v3/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GetTasksReportQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/)
                    ],
                    "type": "ConfluencePage"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v23/*: any*/),
                      (v16/*: any*/),
                      (v24/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/)
                    ],
                    "type": "ConfluenceBlogPost"
                  }
                ]
              }
            ]
          },
          (v25/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetTasksReportQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "InlineTasksQueryResult",
        "kind": "LinkedField",
        "name": "inlineTasks",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphQLInlineTask",
            "kind": "LinkedField",
            "name": "inlineTasks",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v26/*: any*/),
                      (v22/*: any*/)
                    ],
                    "type": "ConfluencePage"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v23/*: any*/),
                      (v16/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      (v22/*: any*/)
                    ],
                    "type": "ConfluenceBlogPost"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          (v25/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4257b78a458e32e70bf16869db78cf05",
    "id": "9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c",
    "metadata": {},
    "name": "GetTasksReportQuery",
    "operationKind": "query",
    "text": "query GetTasksReportQuery($taskQuery:InlineTasksByMetadata!,$cloudId:ID){inlineTasks(tasksQuery:$taskQuery,cloudId:$cloudId){inlineTasks{id,taskId,status,dueAt,createdAt,completedAt,assignedTo{accountId,displayName,profilePicture{path}},createdBy{accountId,displayName},body{adf},container{__typename,...on ConfluencePage{id,pageId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
  }
};
})();

(node as any).hash = "2b6c33814689e4cbcbd78fd4ed149156";

export default node;
